/**
 * playerHelpers.js
 * 
 * functions to handle the players in a game
 */

import { collection, doc, getDoc, getDocs, setDoc } from "firebase/firestore";
import { db } from "../config/firebase";
import { Lobby } from "../assets/DatabaseCollections";

/**
 * Fetches all the players in a given room.
 * @param {string} dbCollection     -   The main AuctionRooms collection name.
 * @param {string} roomID           -   The room ID to fetch teams from.
 * @returns {Array}                 -   Array of players objects
 */
export const fetchPlayersInTheLobby = async (dbCollection, roomID) => {
    try {
        const lobbyRef = collection(db, dbCollection, roomID, Lobby);
        const lobbySnap = await getDocs(lobbyRef);

        const players = lobbySnap.docs.map((docSnap) => ({
            id: docSnap.id,
            ...docSnap.data(),
        }));

        return players;
    } catch (error) {
        console.error("Error fetching players : ", roomID, error);
        return [];
    }
};

/**
 * Checks if a player is already present in the lobby.
 * @param {string} dbCollection     -   The main AuctionRooms collection name.
 * @param {string} roomID           -   The room ID to check in.
 * @param {string} uid           -   The unique ID of the player to verify.
 * @returns {boolean}               -   True if player exists, false otherwise.
 */
export const checkIfPlayerInLobby = async (dbCollection, roomID, userID) => {
    try {
        const playerRef = doc(db, dbCollection, roomID, Lobby, userID);
        const playerSnap = await getDoc(playerRef);

        return playerSnap.exists();
    } catch (error) {
        console.error("Error checking player presence:", error);
        return false;
    }
};

/**
 * Adds Player to the lobby
 * @param {string} dbCollection     -   The main AuctionRooms collection name.
 * @param {string} roomID           -   The room ID to check in.
 * @param {Object} user             -   The information of the user
 * @returns {Boolean}               -   true, if successfully added; false otherwise
 */
export const addPlayerToLobby = async (dbCollection, roomID, user) => {
    try {
        const playerRef = doc(db, dbCollection, roomID, Lobby, user.userID);
        await setDoc(playerRef, {
            userID          :   user.userID,
            pfp             :   user.pfp || '',
            displayName     :   user.displayName || '',
            email           :   user.email || ''
        });

        return true;
    } catch (error) {
        console.error("Error adding player to the lobby : ", error);
        return false;
    }
}